import firebase from 'firebase/app'
import IconButton from '@material-ui/core/IconButton'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined'
import React from 'react'
import { useContext, useEffect, useState } from 'react'
import { increment } from 'daily-dose-common'
import { FirestoreContext } from '../../providers/firestore-provider'
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import { firestore } from '../../firebase-init'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      marginRight: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
    },
    container: {
      display: 'block',
      paddingTop: theme.spacing(0.4),
      paddingBottom: theme.spacing(0.4),
      minHeight: '29px',
    },
  })
)

interface ILikeProps {
  docRef: firebase.firestore.DocumentReference<firebase.firestore.DocumentData>
  likeCount: number
  size: 'small' | 'medium'
}

export const Like = ({ docRef, likeCount, size }: ILikeProps) => {
  const classes = useStyles()
  const { currentUser } = useContext(FirestoreContext)
  const likeDocRef = docRef.collection('likes').doc(currentUser?.id as string) // TODO: Fix id part firestore.types
  const [hasUserLikedDose, sethasUserLikedDose] = useState(false)
  const [localLikeCounts, setLocalLikeCounts] = useState<number>(likeCount)

  // Create a user-to-post relationship
  useEffect(() => {
    const unsubscribeDoseRef = likeDocRef.onSnapshot((snapshot) => {
      sethasUserLikedDose(snapshot.exists)
    })

    return () => {
      unsubscribeDoseRef()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onStarDose = async () => {
    // Remove like
    if (hasUserLikedDose) {
      const batch = firestore.batch()
      batch.update(docRef, {
        likeCount: increment(-1),
      })
      batch.delete(likeDocRef)
      setLocalLikeCounts(localLikeCounts - 1)
      await batch.commit()
    } else {
      const batch = firestore.batch()
      batch.update(docRef, {
        likeCount: increment(1),
      })
      batch.set(likeDocRef, { id: currentUser?.id })
      setLocalLikeCounts(localLikeCounts + 1)
      await batch.commit()
    }
  }

  const displayLikes = () => {
    if (localLikeCounts === 0) return 'Like'

    return `${localLikeCounts}`
  }

  return (
    <IconButton
      aria-label="like"
      onClick={onStarDose}
      size={size || 'medium'}
      className={classes.container}
    >
      <Typography variant="body2" color="primary" className={classes.text}>
        {displayLikes()}
      </Typography>
      {hasUserLikedDose ? (
        <ThumbUpIcon color="primary" fontSize="inherit" />
      ) : (
        <ThumbUpOutlinedIcon color="primary" fontSize="inherit" />
      )}
    </IconButton>
  )
}
